/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Button, Input, Form } from 'antd';

import IntlMessages from 'util/IntlMessages';
import { userSignIn } from 'redux/actions/Auth';

const SignInPuppeteer = (props) => {
  const dispatch = useDispatch();
  const { history } = props;

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const onFinish = (values) => {
    dispatch(userSignIn(values));
  };

  const token = useSelector(({ auth }) => auth.token);
  const authUser = useSelector(({ auth }) => auth.authUser);

  useEffect(() => {
    if (token !== null && authUser) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('action')) {
        history.push(`/${urlParams.get('action')}${window.location.search}`);
      }
    }
  }, [authUser, history, token]);

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-login-content">
            <Form
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
              autoComplete="off"
            >
              <Form.Item
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                ]}
                name="email"
              >
                <Input placeholder="Email" autoComplete="username" />
              </Form.Item>
              <Form.Item
                rules={[
                  { required: true, message: 'Please input your Password!' },
                ]}
                name="password"
              >
                <Input type="password" placeholder="Password" autoComplete="off" />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  className="signinbtn gx-mb-0"
                  htmlType="submit"
                >
                  <IntlMessages id="app.userAuth.signIn" />
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

SignInPuppeteer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default SignInPuppeteer;
